export function addNDaysToDate(date, n) {
    date.setDate(date.getDate() + n)
    return date.toISOString().split('T')[0]
}